export default __webpack_public_path__ + "static/media/members_receive_4.5966bdc2.jpg";